import { ErrorWithFields as r } from "./index6.mjs";
class e extends r {
}
export {
  e as ConflictError
};
